import { Skeleton } from '@mantine/core';

import styles from './WizardFreightRateCard.module.css';

export const WizardFreightRateCardSkeleton = () => (
  <div className={styles.card} data-testid='freight-rate-card-skeleton'>
    <div className={styles.info}>
      <Skeleton className={styles.logoBox} radius='sm' />
      <div className={styles.infoColumn}>
        <div className={styles.nameRow}>
          <Skeleton height={14} mb={6} radius='sm' width='100%' />
        </div>
        <div className={styles.selectors}>
          <Skeleton height={28} radius='sm' />
          <Skeleton height={28} radius='sm' />
        </div>
      </div>
    </div>
  </div>
);
